/**
 * @module cercaliagl/view/SVGUtils
 */
import IconsSVG from './IconsSVG';
/**
 * @param {string} svgPaths SVGPaths
 * @return {string} SVG
 */
export function createSVGIconFromPath(svgPaths) {
    var innerSvg = svgPaths.indexOf('<') === -1 ? "<path d=\"".concat(svgPaths, "\"/>") : svgPaths;
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">".concat(innerSvg, "</svg>");
}
/**
 * @param {string} iconName Icon name defined in IconsSVG
 * @return {string} SVG html format.
 */
export function createSVGIcon(iconName) {
    var svgPaths = IconsSVG[iconName] ? IconsSVG[iconName].join('') : '';
    return createSVGIconFromPath(svgPaths);
}
/**
 * @param {string} iconName Icon name
 * @param {number} [numPaths] Number of paths
 */
export function createSpanIconByNumPath(iconName, numPaths) {
    if (numPaths === void 0) { numPaths = 0; }
    var html = "<span class=\"".concat(iconName, "\">").concat(Array(numPaths).fill().map(function (_, i) { return "<i class=\"path".concat(i + 1, "\"></i>"); }).join(''), "</span>");
    return html;
}
//# sourceMappingURL=SVGUtils.js.map